<template>
  <v-app dark>

    <v-navigation-drawer app v-model="drawer" :width="200" :mobile-break-point="960" disable-resize-watcher>
      <v-toolbar flat height="auto" color="transparent">
        <v-btn-toggle v-model="sidebar" id="toolbar-sidebar" mandatory class="transparent">
          <v-btn flat large value="viewThumbnail" id="viewThumbnail" title="Show Thumbnails" tabindex="2" data-l10n-id="thumbs">
            <v-icon data-recite-skip="true">dashboard</v-icon>
          </v-btn>

          <v-btn flat large value="viewOutline" id="viewOutline" title="Show Document Outline (double-click to expand/collapse all items)" tabindex="3" data-l10n-id="document_outline">
            <v-icon data-recite-skip="true">list</v-icon>
          </v-btn>

          <v-btn flat large value="viewAttachments" id="viewAttachments" title="Show Attachments" tabindex="4" data-l10n-id="attachments">
            <v-icon data-recite-skip="true">attach_file</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-toolbar>

      <div id="sidebarContent">
        <div id="thumbnailView">
        </div>
        <div id="outlineView" class="hidden">
        </div>
        <div id="attachmentsView" class="hidden">
        </div>
      </div>
    </v-navigation-drawer>

    <app-proxy></app-proxy>
    <app-toolbar v-model="drawer" @initialized="initialize"></app-toolbar>

    <v-content>


      <div id="outerContainer">
        <div id="mainContainer">

          <div id="viewerContainer" tabindex="0">
            <div id="viewer" class="pdfViewer container px-1 py-2 fluid text-xs-center"></div>
          </div>

          <v-dialog v-model="dialog" content-class="elevation-0 ma-0 fill-height">
            <v-layout column fill-height align-center justify-center>
              <v-progress-circular
                :rotate="-90"
                :size="200"
                :width="10"
                :value="progress"
                color="blue-grey lighten-4"
                class="elevation-10"
                v-if="dialog"
              >
                <v-layout column>
                  <v-flex text-xs-center><span class="display-3 font-weight-medium">{{ progress }}</span>&nbsp;<span class="headline">%</span></v-flex>
                  <v-flex text-xs-center subheading>Loading...</v-flex>
                </v-layout>
              </v-progress-circular>
            </v-layout>
          </v-dialog>

          <div id="errorWrapper" hidden="true" class="container">
            <div id="errorMessageLeft">
              <span id="errorMessage"></span>
              <button id="errorShowMore" data-l10n-id="error_more_info">
                More Information
              </button>
              <button id="errorShowLess" data-l10n-id="error_less_info" hidden='true'>
                Less Information
              </button>
            </div>
            <div id="errorMessageRight">
              <button id="errorClose" data-l10n-id="error_close">
                Close
              </button>
            </div>
            <div class="clearBoth"></div>
            <textarea id="errorMoreInfo" hidden='true' readonly="readonly"></textarea>
          </div>
        </div> <!-- mainContainer -->

        <div id="overlayContainer" class="hidden d-flex justify-center align-center">
          <div id="passwordOverlay" class="container hidden">
            <div class="dialog grey darken-3 elevation-5">
              <div class="row">
                <p id="passwordText" data-l10n-id="password_label">Enter the password to open this PDF file:</p>
              </div>
              <div class="row">
                <input type="password" id="password" class="toolbarField">
              </div>
              <div class="buttonRow">
                <button id="passwordCancel" class="overlayButton"><span data-l10n-id="password_cancel">Cancel</span></button>
                <button id="passwordSubmit" class="overlayButton"><span data-l10n-id="password_ok">OK</span></button>
              </div>
            </div>
          </div>
          <div id="documentPropertiesOverlay" class="container hidden">
            <div class="dialog grey darken-3 elevation-5">
              <div class="row">
                <span data-l10n-id="document_properties_file_name">File name:</span> <p id="fileNameField">-</p>
              </div>
              <div class="row">
                <span data-l10n-id="document_properties_file_size">File size:</span> <p id="fileSizeField">-</p>
              </div>
              <div class="separator"></div>
              <div class="row">
                <span data-l10n-id="document_properties_title">Title:</span> <p id="titleField">-</p>
              </div>
              <div class="row">
                <span data-l10n-id="document_properties_author">Author:</span> <p id="authorField">-</p>
              </div>
              <div class="row">
                <span data-l10n-id="document_properties_subject">Subject:</span> <p id="subjectField">-</p>
              </div>
              <div class="row">
                <span data-l10n-id="document_properties_keywords">Keywords:</span> <p id="keywordsField">-</p>
              </div>
              <div class="row">
                <span data-l10n-id="document_properties_creation_date">Creation Date:</span> <p id="creationDateField">-</p>
              </div>
              <div class="row">
                <span data-l10n-id="document_properties_modification_date">Modification Date:</span> <p id="modificationDateField">-</p>
              </div>
              <div class="row">
                <span data-l10n-id="document_properties_creator">Creator:</span> <p id="creatorField">-</p>
              </div>
              <div class="separator"></div>
              <div class="row">
                <span data-l10n-id="document_properties_producer">PDF Producer:</span> <p id="producerField">-</p>
              </div>
              <div class="row">
                <span data-l10n-id="document_properties_version">PDF Version:</span> <p id="versionField">-</p>
              </div>
              <div class="row">
                <span data-l10n-id="document_properties_page_count">Page Count:</span> <p id="pageCountField">-</p>
              </div>
              <div class="buttonRow">
                <button id="documentPropertiesClose" class="overlayButton"><span data-l10n-id="document_properties_close">Close</span></button>
              </div>
            </div>
          </div>
          <div id="printServiceOverlay" class="container hidden">
            <div class="dialog grey darken-3 elevation-5">
              <div class="mb-2">
                <span data-l10n-id="print_progress_message">Preparing document for printing…</span>
                <span data-l10n-id="print_progress_percent" data-l10n-args='{ "progress": 0 }' class="relative-progress ml-2">0%</span>
              </div>
              <div class="mb-2 align-center d-flex">
                <progress value="0" max="100"></progress>
              </div>
              <div class="buttonRow">
                <button id="printCancel" class="overlayButton"><span data-l10n-id="print_progress_close">Cancel</span></button>
              </div>
            </div>
          </div>
        </div>  <!-- overlayContainer -->

      </div> <!-- outerContainer -->
      <div id="printContainer"></div>

      <v-speed-dial
        :value="true"
        fixed
        right
        bottom
        class="mr-4 pr-3 mb-3"
      >
        <v-btn light fab small color="grey lighten-3" class="elevation-2" @click.stop id="zoomOut" title="Zoom Out"
               tabindex="21" data-l10n-id="zoom_out">
          <v-icon data-recite-skip="true" size="20" color="grey darken-3">remove</v-icon>
        </v-btn>

        <v-btn light fab small color="grey lighten-3" class="elevation-2" @click.stop id="zoomIn" title="Zoom In"
               tabindex="22" data-l10n-id="zoom_in">
          <v-icon data-recite-skip="true" size="20" color="grey darken-3">add</v-icon>
        </v-btn>

        <v-btn v-if="fitPage" light fab small color="grey lighten-3" @click.stop="setFitWidth" class="mb-4 elevation-2">
          <v-icon data-recite-skip="true" size="20" color="grey darken-3">fullscreen</v-icon>
        </v-btn>
        <v-btn v-else light fab small color="grey lighten-3" @click.stop="setFitPage" class="mb-4 elevation-2">
          <v-icon data-recite-skip="true" size="20" color="grey darken-3">fullscreen_exit</v-icon>
        </v-btn>

      </v-speed-dial>
    </v-content>
  </v-app>
</template>

<script>
  import AppProxy from '@/components/AppProxy'
  import AppToolbar from '@/components/AppToolbar'

  export default {
    name: 'App',
    components: {
      AppProxy,
      AppToolbar
    },

    data () {
      return {
        drawer: false,
        sidebar: null,
        fitPage: false,
        scaleEl: null,
        progress: -1,
        dialog: false
      }
    },

    mounted () {
      if (window.MutationObserver) {
        const element = document.querySelector('#loadingBar .progress')
        const muObs = new MutationObserver((mutations) => {
          mutations.forEach((item) => {
            const val = parseInt(item.target.style.width)

            if (this.progress === -1 && val !== 100) {
              this.dialog = true
            }

            this.progress = val


            if (this.progress === 100 && this.dialog) {
              setTimeout(() => {
                this.dialog = false
              }, 1000)
            }
          })
        })

        muObs.observe(element, {attributes: true, attributeFilter: ['style']})
      }
    },

    methods: {
      initialize () {
        this.scaleEl = document.getElementById('scaleSelect')
      },

      hasClass (element, className) {
        return ( (" " + element.className + " ").replace(/[\n\t]/g, " ").indexOf(" " + className + " ") > -1 )
      },

      trigger (element, eventName, payload) {
        if ('createEvent' in document) {
          const evt = document.createEvent('HTMLEvents')
          evt.initEvent(eventName, false, true)
          element.dispatchEvent(evt, payload)
        }
        else {
          element.fireEvent('on' + eventName)
        }
      },

      setFitPage () {
        this.fitPage = true
        this.scaleEl.value = 'page-fit'
        this.trigger(this.scaleEl, 'change')
      },

      setFitWidth () {
        this.fitPage = false
        this.scaleEl.value = 'page-width'
        this.trigger(this.scaleEl, 'change')
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/App.vue